import React from 'react';
import { useTranslation } from 'react-i18next';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import CrudManager from '../../../components/common/CrudManager';
import PeopleService from '../../../services/PeopleService';
import PeopleForm from './PeopleForm';

const People = () => {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'fullName',
      label: 'people.fullName',
      sortable: true,
      showInFilter: true,
      filterPlaceholder: 'people.fullName',
      filterSize: 'large'
    },
    {
      key: 'documentNumber',
      label: 'people.documentNumber',
      sortable: true,
      showInFilter: true,
      filterPlaceholder: 'people.documentNumber',
      filterSize: 'large'
    },
    {
      key: 'email',
      label: 'people.email',
      sortable: true,
      showInFilter: true,
      filterPlaceholder: 'people.email',
      filterSize: 'large'
    },
    {
      key: 'phone',
      label: 'people.phone',
      sortable: true,
      showInFilter: true,
      filterPlaceholder: 'people.phone',
      filterSize: 'large'
    },
    {
      key: 'peopleEnabled',
      label: 'people.enabled',
      sortable: false,
      render: (row) => (
        <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <input
            type="checkbox"
            defaultChecked={row.enabled || false}
            onChange={(e) => PeopleService.updateEnabled(row.id, { enabled: e.target.checked })}
          />
        </span>
      ),
      showInFilter: true,
      filterKey: 'enabled',
      filterType: 'checkbox',
      filterSize: 'small'
    },
    {
      key: 'userEnabled',
      label: 'people.userStatus',
      sortable: true,
      showInForm: false,
      render: (row) => {
        const enabled = !!row.userEnabled;
        return (
          <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <i
              className={`fa ${enabled ? 'fa-user-check' : 'fa-user-slash'}`}
              title={enabled ? t('people.userEnabled') : t('people.userDisabled')}
              aria-label={enabled ? t('people.userEnabled') : t('people.userDisabled')}
              style={{
                color: enabled ? '#28a745' : '#6c757d',
                fontSize: '16px'
              }}
            ></i>
          </span>
        );
      },
      showInFilter: true,
      filterPlaceholder: 'people.user'
    }
  ];

  return (
    <CrudManager
      service={PeopleService}
      columns={columns}
      entityName="people"
      icon={faUsers}
      customFormComponent={PeopleForm}
    />
  );
};

export default People;
